// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1vHjd","header":"PatientBlock_header__27Uv8","label":"PatientBlock_label__2pO68","option":"PatientBlock_option__2fAVH"};